export default __webpack_public_path__ + "static/media/gif5_slow.da10f19f.gif";